import type { InputModality } from '@angular/cdk/a11y'

/**
 * Moves focus from code, showing the focus ring only after keyboard input.
 * @param {HTMLElement} target Element that receives focus.
 * @param {InputModality} modality Most recent input type, from the CDK input modality detector.
 */
export function focusWithoutTouchRing(target: HTMLElement, modality: InputModality): void {
  if (modality === 'keyboard') {
    target.focus({ preventScroll: true })

    return
  }

  // Browsers ring a scripted focus when the previous element had a ring, and text fields always have one.
  const active = target.ownerDocument.activeElement

  if (active instanceof HTMLElement && active !== target) {
    active.blur()
  }

  target.focus({ preventScroll: true, focusVisible: false })
}
